(function () {
  'use strict';

  var internalHosts = null;
  var observerStarted = false;

  function normalizeHost(host) {
    return String(host || '')
      .toLowerCase()
      .replace(/^www\./, '');
  }

  function buildInternalHosts() {
    if (internalHosts) return internalHosts;

    internalHosts = new Set();
    internalHosts.add(normalizeHost(window.location.hostname));

    if (window.Shopify && Shopify.shop) {
      internalHosts.add(normalizeHost(Shopify.shop));
    }

    document.querySelectorAll('[data-shop-domain]').forEach(function (el) {
      internalHosts.add(normalizeHost(el.getAttribute('data-shop-domain')));
    });

    return internalHosts;
  }

  function isInternalNavigationLink(link) {
    if (!link || link.tagName !== 'A') return false;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return true;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return true;

    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin) return true;
      return buildInternalHosts().has(normalizeHost(url.hostname));
    } catch (e) {
      return true;
    }
  }

  function isPopupLink(link) {
    if (!link || link.tagName !== 'A') return false;
    if (link.hasAttribute('data-tcb-allow-blank')) return true;
    if (link.hasAttribute('data-popup-type')) return true;
    if (link.hasAttribute('data-tcb-popup')) return true;
    if (link.closest('.pswp')) return true;
    return false;
  }

  function stripBlankTarget(link) {
    if (!link || link.getAttribute('target') !== '_blank') return;
    if (isPopupLink(link)) return;

    link.removeAttribute('target');
    link.removeAttribute('aria-describedby');

    var rel = link.getAttribute('rel') || '';
    rel = rel
      .split(/\s+/)
      .filter(function (token) {
        return token && token !== 'noopener' && token !== 'noreferrer';
      })
      .join(' ');
    if (rel) link.setAttribute('rel', rel);
    else link.removeAttribute('rel');
  }

  function fixLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('a[target="_blank"]').forEach(stripBlankTarget);
  }

  function scheduleFix() {
    fixLinks(document);
    window.setTimeout(function () {
      fixLinks(document);
    }, 0);
    window.setTimeout(function () {
      fixLinks(document);
    }, 100);
  }

  function watchForBlankTargets() {
    if (observerStarted || !window.MutationObserver || !document.body) return;
    observerStarted = true;

    var timer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fixLinks(document);
      }, 50);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['target', 'href'],
    });
  }

  function init() {
    scheduleFix();
    window.addEventListener('load', scheduleFix);
    watchForBlankTargets();
  }

  window.TcbLinkBehavior = {
    fixLinks: fixLinks,
    isInternalNavigationLink: isInternalNavigationLink,
    isPopupLink: isPopupLink,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixLinks(event.target);
  });
})();
